var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-home-intro-stars"},[_c('shared-stars',{attrs:{"quantity":_vm.responsiveStarsQty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }